export const AI_PROMPT_STORAGE_KEY = 'ai_auto_prompt';
export const AI_PROMPT_ATTACHMENTS_STORAGE_KEY = 'ai_auto_prompt_attachments';
export const AI_PROMPT_CONTACT_STORAGE_KEY = 'ai_auto_prompt_contact';

export function savePromptToSession(prompt) {
  try {
    if (typeof sessionStorage === 'undefined') return;
    sessionStorage.setItem(AI_PROMPT_STORAGE_KEY, prompt);
  } catch (error) {
    console.warn('[aiPromptStorage] Unable to persist prompt', error);
  }
}

export function saveAttachmentsToSession(attachments = []) {
  try {
    if (typeof sessionStorage === 'undefined') return;
    if (!attachments || attachments.length === 0) {
      sessionStorage.removeItem(AI_PROMPT_ATTACHMENTS_STORAGE_KEY);
      return;
    }
    sessionStorage.setItem(
      AI_PROMPT_ATTACHMENTS_STORAGE_KEY,
      JSON.stringify(attachments),
    );
  } catch (error) {
    console.warn('[aiPromptStorage] Unable to persist attachments', error);
  }
}

export function loadPromptFromSession() {
  try {
    if (typeof sessionStorage === 'undefined') return null;
    return sessionStorage.getItem(AI_PROMPT_STORAGE_KEY);
  } catch (error) {
    console.warn('[aiPromptStorage] Unable to read prompt', error);
    return null;
  }
}

export function loadAttachmentsFromSession() {
  try {
    if (typeof sessionStorage === 'undefined') return [];
    const raw = sessionStorage.getItem(AI_PROMPT_ATTACHMENTS_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      return parsed;
    }
    return [];
  } catch (error) {
    console.warn('[aiPromptStorage] Unable to read attachments', error);
    return [];
  }
}

export function clearPromptSession() {
  try {
    if (typeof sessionStorage === 'undefined') return;
    sessionStorage.removeItem(AI_PROMPT_STORAGE_KEY);
  } catch (error) {
    console.warn('[aiPromptStorage] Unable to clear prompt', error);
  }
}

export function clearAttachmentsSession() {
  try {
    if (typeof sessionStorage === 'undefined') return;
    sessionStorage.removeItem(AI_PROMPT_ATTACHMENTS_STORAGE_KEY);
  } catch (error) {
    console.warn('[aiPromptStorage] Unable to clear attachments', error);
  }
}

export function saveContactToSession(contact = null) {
  try {
    if (typeof sessionStorage === 'undefined') return;
    if (!contact) {
      sessionStorage.removeItem(AI_PROMPT_CONTACT_STORAGE_KEY);
      return;
    }
    const payload = {
      ...contact,
      updatedAt: new Date().toISOString(),
    };
    sessionStorage.setItem(AI_PROMPT_CONTACT_STORAGE_KEY, JSON.stringify(payload));
  } catch (error) {
    console.warn('[aiPromptStorage] Unable to persist contact', error);
  }
}

export function loadContactFromSession() {
  try {
    if (typeof sessionStorage === 'undefined') return null;
    const raw = sessionStorage.getItem(AI_PROMPT_CONTACT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object') {
      return parsed;
    }
    return null;
  } catch (error) {
    console.warn('[aiPromptStorage] Unable to read contact', error);
    return null;
  }
}

export function clearContactSession() {
  try {
    if (typeof sessionStorage === 'undefined') return;
    sessionStorage.removeItem(AI_PROMPT_CONTACT_STORAGE_KEY);
  } catch (error) {
    console.warn('[aiPromptStorage] Unable to clear contact', error);
  }
}
